/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.transcript.be.rpc.FeedbackAppChirpService
 */
import * as References from './FeedbackAppChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.transcript.be.rpc.FeedbackAppChirpService#submitFeedback
 */
export const SUBMIT_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_transcript_be_rpc_FeedbackAppChirpService_submitFeedback';
export const SUBMIT_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['transcriptId', 'transcribedCrmObjectId', 'transcribedCrmObjectTypeId', 'vote', 'feedbackGeneric', 'maybeFeedbackFreeform'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.submitFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});